import React from "react";
import "./feature-bar.scss";

const FeatureBar = () => {
  return (
    <section className="feature-bar">
      <div className="feature-bar-inner">
        <div className="feature-item">
          <div className="feature-icon">
            <i className="fas fa-shield-check"></i>
          </div>

          <div className="feature-content">
            <h5>Safety Focused</h5>
            <p>
              Industry leading
              <br />
              safety standards
            </p>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-icon">
            <i className="fas fa-users"></i>
          </div>

          <div className="feature-content">
            <h5>Experienced Team</h5>
            <p>
              Skilled professionals
              <br />
              you can trust
            </p>
          </div>
        </div>

        <div className="feature-item">
<div className="feature-icon feature-icon-no-circle">
  <img src="/images/australia.png" alt="Australia" />
</div>

          <div className="feature-content">
            <h5>Nationwide Service</h5>
            <p>
              Delivering Australia
              <br />
              wide
            </p>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-icon">
            <i className="far fa-clock"></i>
          </div>

          <div className="feature-content">
            <h5>24/7 Support</h5>
            <p>
              Around the clock
              <br />
              support
            </p>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-icon">
            <i className="fas fa-phone-alt"></i>
          </div>

          <div className="feature-content">
            <h5>
              <a href="tel:1300678723">1300 MRTRAFFIC</a>
            </h5>
            <p>
              Speak to our team
              <br />
              today
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureBar;